module.exports = __webpack_public_path__ + "static/media/Colonization of Mars.0b5fc930.jpg";